import React, { Component } from "react";

export default class Gim extends Component {
  render() {
    return <div></div>;
  }
}
